import classNames from 'classnames';

export interface ChipProps {
  active: boolean;
  label: string;
  onClick: () => void;
}

export const Chip: React.FC<ChipProps> = ({ active, label, onClick }) => {
  return (
    <div
      onClick={onClick}
      className={classNames('cursor-pointer rounded-full border px-4 py-1', {
        'bg-primary border-primary hover:bg-hover focus:bg-hover hover:border-hover focus:border-hover text-white':
          active,
        'text-grey-700 border-grey-500 hover:border-grey-700 focus:border-grey-500 bg-white':
          !active,
      })}
    >
      {label}
    </div>
  );
};
